export default {
  EXISTS_TIER: `#graphql
  query existsTier($tier: String!) {
    existsTier(tier: $tier)           
  }`,

  COUNT: `#graphql
  query countTiers {
    countTiers
  }`,

  GET_ALL: `#graphql
  query getTiers($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getTiers(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        tier,
        name,
        warehouse,
        shelf
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getTiersHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getTiersHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        tier,
        name,
        warehouse,
        shelf,
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewTier($tier: TierInput!) {
    newTier(input: $tier)
    {
      tier,
      name,
      warehouse,
      shelf
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateTier($tier: String!, $tierUpdate: TierUpdateInput!) {
    updateTier(tier:$tier, tierUpdate: $tierUpdate)
    {
      tier
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteTier($tier: String!) {
    deleteTier(tier:$tier)
    {
      tier
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/tier.js